import React, { useState } from 'react';

export default function Packages() {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'All Packages', icon: '🗺️' },
    { id: 'popular', label: 'Popular', icon: '⭐' },
    { id: 'adventure', label: 'Adventure', icon: '🏔️' },
    { id: 'heritage', label: 'Heritage', icon: '🏛️' },
    { id: 'honeymoon', label: 'Honeymoon', icon: '💑' }
  ];

  const packages = [
    {
      id: 1,
      title: 'Kullu Manali Tour',
      category: ['popular', 'adventure', 'honeymoon'],
      duration: '6 Nights / 7 Days',
      destinations: 'Kullu • Manali • Shimla • Kasol',
      price: '₹11,999',
      originalPrice: '₹13,999',
      image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=500&h=300&fit=crop',
      rating: 4.9,
      reviews: 189,
      features: ['Luxury Car', 'Mountain Resorts', 'All Meals', 'Activities'],
      badge: 'Top Priority',
      discount: '10% OFF'
    },
    {
      id: 2,
      title: 'Kashmir Paradise Tour',
      category: ['honeymoon', 'adventure', 'popular'],
      duration: '6 Nights / 7 Days',
      destinations: 'Srinagar • Gulmarg • Pahalgam • Sonmarg',
      price: '₹16,999',
      originalPrice: '₹18,999',
      image: 'https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=500&h=300&fit=crop',
      rating: 4.9,
      reviews: 201,
      features: ['Houseboat Stay', 'Shikara Ride', 'All Transfers', 'Romantic Setup'],
      badge: 'Romantic',
      discount: '10% OFF'
    },
    {
      id: 3,
      title: 'Goa Beach Holiday',
      category: ['honeymoon', 'popular'],
      duration: '5 Nights / 6 Days',
      destinations: 'North Goa • South Goa',
      price: '₹11,999',
      originalPrice: '₹13,999',
      image: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=500&h=300&fit=crop',
      rating: 4.8,
      reviews: 223,
      features: ['Beach Resort', 'Water Sports', 'Sightseeing', 'Candlelight Dinner'],
      badge: 'Relaxing',
      discount: '10% OFF'
    },
    {
      id: 4,
      title: 'Rajasthan Heritage Tour',
      category: ['heritage', 'popular'],
      duration: '10 Nights / 11 Days',
      destinations: 'Jaipur • Udaipur • Jodhpur • Jaisalmer',
      price: '₹24,999',
      originalPrice: '₹27,999',
      image: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?w=500&h=300&fit=crop',
      rating: 4.7,
      reviews: 156,
      features: ['Tempo Traveller', 'Heritage Hotels', 'Cultural Tours', 'Camel Safari'],
      badge: 'Premium',
      discount: '10% OFF'
    },
    {
      id: 5,
      title: 'Golden Triangle Tour',
      category: ['popular', 'heritage'],
      duration: '6 Nights / 7 Days',
      destinations: 'Delhi • Agra • Jaipur',
      price: '₹12,999',
      originalPrice: '₹14,999',
      image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=500&h=300&fit=crop',
      rating: 4.8,
      reviews: 245,
      features: ['Tempo Traveller', 'Hotel Stay', 'Meals', 'Guide'],
      badge: 'Best Seller',
      discount: '10% OFF'
    },
    {
      id: 6,
      title: 'Kerala Backwaters',
      category: ['honeymoon', 'popular'],
      duration: '6 Nights / 7 Days',
      destinations: 'Munnar • Thekkady • Alleppey • Cochin',
      price: '₹19,999',
      originalPrice: '₹22,999',
      image: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=500&h=300&fit=crop',
      rating: 4.9,
      reviews: 187,
      features: ['Houseboat', 'Hill Station Stay', 'Ayurvedic Spa', 'Tea Gardens'],
      badge: 'Serene',
      discount: '10% OFF'
    },
    {
      id: 7,
      title: 'Char Dham Yatra',
      category: ['heritage'],
      duration: '12 Nights / 13 Days',
      destinations: 'Yamunotri • Gangotri • Kedarnath • Badrinath',
      price: '₹32,999',
      originalPrice: '₹36,999',
      image: 'https://images.unsplash.com/photo-1585159812596-fac104f2f069?w=500&h=300&fit=crop',
      rating: 4.7,
      reviews: 134,
      features: ['Tempo Traveller', 'Hotels', 'All Meals', 'Spiritual Guide'],
      badge: 'Spiritual',
      discount: '10% OFF'
    },
    {
      id: 8,
      title: 'Jim Corbett Wildlife',
      category: ['adventure'],
      duration: '3 Nights / 4 Days',
      destinations: 'Jim Corbett National Park',
      price: '₹9,999',
      originalPrice: '₹11,499',
      image: 'https://images.unsplash.com/photo-1549366021-9f761d450615?w=500&h=300&fit=crop',
      rating: 4.6,
      reviews: 98,
      features: ['Safari Jeep', 'Forest Lodge', 'Jungle Safari', 'Bird Watching'],
      badge: 'Wildlife',
      discount: '10% OFF'
    },
    {
      id: 9,
      title: 'Leh Ladakh Adventure',
      category: ['adventure'],
      duration: '8 Nights / 9 Days',
      destinations: 'Leh • Nubra • Pangong • Khardung La',
      price: '₹28,999',
      originalPrice: '₹32,999',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      rating: 4.8,
      reviews: 178,
      features: ['SUV/Tempo', 'Camping', 'Oxygen Support', 'Adventure Activities'],
      badge: 'Thrilling',
      discount: '10% OFF'
    }
  ];

  const filteredPackages = activeCategory === 'all' 
    ? packages 
    : packages.filter(pkg => pkg.category.includes(activeCategory));

  return (
    <section
      id="packages"
      className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-sky-50 via-blue-50 to-cyan-50 relative overflow-hidden"
    >
      {/* Animated Background */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-sky-300/40 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-300/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
      <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-blue-200/25 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 via-blue-600 to-cyan-500 drop-shadow-lg mb-4 animate-pulse">
            Explore Our Tour Packages
          </h2>
          <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-600">
            Handpicked destinations and carefully crafted itineraries for your perfect vacation
          </p>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-sky-500 to-cyan-500 mx-auto rounded-full mt-4"></div>
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 ${
                activeCategory === category.id
                  ? 'bg-gradient-to-r from-sky-500 to-cyan-500 text-white shadow-lg shadow-sky-400/50 scale-105'
                  : 'bg-white/70 backdrop-blur-sm text-gray-700 hover:bg-white/90 border border-sky-300 shadow-md'
              }`}
            >
              <span className="mr-2">{category.icon}</span>
              {category.label}
            </button>
          ))}
        </div>

        {/* Packages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {filteredPackages.map((pkg, index) => (
            <div
              key={pkg.id}
              className="bg-white/70 backdrop-blur-sm rounded-2xl shadow-lg border border-sky-200 overflow-hidden hover:shadow-2xl hover:shadow-sky-300/50 hover:-translate-y-2 transition-all duration-300 group"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Image */}
              <div className="relative overflow-hidden h-48 sm:h-56">
                <img
                  src={pkg.image}
                  alt={pkg.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                {/* Badge */}
                <div className="absolute top-3 left-3 bg-gradient-to-r from-sky-500 to-blue-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                  {pkg.badge}
                </div>
                {/* Discount */}
                <div className="absolute top-3 right-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                  {pkg.discount}
                </div>
              </div>

              {/* Content */}
              <div className="p-5 sm:p-6">
                {/* Title & Rating */}
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-sky-600 transition-colors">
                    {pkg.title}
                  </h3>
                  <div className="flex items-center gap-1 bg-sky-100 px-2 py-1 rounded-lg border border-sky-300">
                    <svg className="w-4 h-4 text-cyan-600" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                    <span className="text-xs font-semibold text-gray-700">{pkg.rating}</span>
                  </div>
                </div>

                {/* Duration & Destinations */}
                <div className="space-y-2 mb-4">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <svg className="w-4 h-4 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span className="font-medium">{pkg.duration}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <svg className="w-4 h-4 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span className="font-medium">{pkg.destinations}</span>
                  </div>
                </div>

                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {pkg.features.map((feature, i) => (
                    <span
                      key={i}
                      className="px-3 py-1 bg-sky-100 text-sky-700 rounded-full text-xs font-medium border border-sky-300"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* Price & CTA */}
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div>
                    <div className="flex items-baseline gap-2">
                      <span className="text-2xl font-bold text-sky-600">{pkg.price}</span>
                      <span className="text-sm text-gray-500 line-through">{pkg.originalPrice}</span>
                    </div>
                    <p className="text-xs text-gray-500">Per Person</p>
                  </div>
                  <a
                    href={`https://wa.me/918929550611?text=Hi! I'm interested in ${pkg.title}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-semibold rounded-full shadow-md hover:shadow-lg hover:shadow-cyan-400/50 hover:scale-105 transition-all duration-300 text-sm"
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 sm:mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-sky-400 via-blue-500 to-cyan-400 p-1 rounded-2xl shadow-2xl shadow-sky-400/30">
            <div className="bg-white px-8 py-6 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Can't find what you're looking for?
              </h3>
              <p className="text-gray-600 mb-4">
                We create customized tour packages tailored to your preferences!
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <a
                  href="https://wa.me/918929550611"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold rounded-full shadow-lg hover:shadow-cyan-400/50 hover:scale-105 transition-all duration-200"
                >
                  📱 WhatsApp Us
                </a>
                <a
                  href="tel:+918929550611"
                  className="px-6 py-3 bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold rounded-full shadow-lg hover:shadow-sky-400/50 hover:scale-105 transition-all duration-200"
                >
                  📞 Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


// import React, { useState } from 'react';

// export default function Packages() {
//   const [activeCategory, setActiveCategory] = useState('all');

//   const categories = [
//     { id: 'all', label: 'All Packages', icon: '🗺️' },
//     { id: 'popular', label: 'Popular', icon: '⭐' },
//     { id: 'adventure', label: 'Adventure', icon: '🏔️' },
//     { id: 'heritage', label: 'Heritage', icon: '🏛️' },
//     { id: 'honeymoon', label: 'Honeymoon', icon: '💑' }
//   ];

//   const packages = [
//     {
//       id: 1,
//       title: 'Golden Triangle Tour',
//       category: ['popular', 'heritage'],
//       duration: '6 Nights / 7 Days',
//       destinations: 'Delhi • Agra • Jaipur',
//       price: '₹12,999',
//       originalPrice: '₹14,999',
//       image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=500&h=300&fit=crop',
//       rating: 4.8,
//       reviews: 245,
//       features: ['Tempo Traveller', 'Hotel Stay', 'Meals', 'Guide'],
//       badge: 'Best Seller',
//       discount: '10% OFF'
//     },
//     {
//       id: 2,
//       title: 'Shimla Manali Tour',
//       category: ['popular', 'adventure', 'honeymoon'],
//       duration: '6 Nights / 7 Days',
//       destinations: 'Shimla • Manali • Kullu',
//       price: '₹18,499',
//       originalPrice: '₹20,999',
//       image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=500&h=300&fit=crop',
//       rating: 4.9,
//       reviews: 189,
//       features: ['Luxury Car', 'Mountain Resorts', 'All Meals', 'Activities'],
//       badge: 'Top Rated',
//       discount: '10% OFF'
//     },
//     {
//       id: 3,
//       title: 'Rajasthan Heritage Tour',
//       category: ['heritage', 'popular'],
//       duration: '10 Nights / 11 Days',
//       destinations: 'Jaipur • Udaipur • Jodhpur • Jaisalmer',
//       price: '₹24,999',
//       originalPrice: '₹27,999',
//       image: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?w=500&h=300&fit=crop',
//       rating: 4.7,
//       reviews: 156,
//       features: ['Tempo Traveller', 'Heritage Hotels', 'Cultural Tours', 'Camel Safari'],
//       badge: 'Premium',
//       discount: '10% OFF'
//     },
//     {
//       id: 4,
//       title: 'Kashmir Paradise Tour',
//       category: ['honeymoon', 'adventure'],
//       duration: '6 Nights / 7 Days',
//       destinations: 'Srinagar • Gulmarg • Pahalgam • Sonmarg',
//       price: '₹21,999',
//       originalPrice: '₹24,999',
//       image: 'https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=500&h=300&fit=crop',
//       rating: 4.9,
//       reviews: 201,
//       features: ['Houseboat Stay', 'Shikara Ride', 'All Transfers', 'Romantic Setup'],
//       badge: 'Romantic',
//       discount: '10% OFF'
//     },
//     {
//       id: 5,
//       title: 'Leh Ladakh Adventure',
//       category: ['adventure'],
//       duration: '8 Nights / 9 Days',
//       destinations: 'Leh • Nubra • Pangong • Khardung La',
//       price: '₹28,999',
//       originalPrice: '₹32,999',
//       image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
//       rating: 4.8,
//       reviews: 178,
//       features: ['SUV/Tempo', 'Camping', 'Oxygen Support', 'Adventure Activities'],
//       badge: 'Thrilling',
//       discount: '10% OFF'
//     },
//     {
//       id: 6,
//       title: 'Char Dham Yatra',
//       category: ['heritage'],
//       duration: '12 Nights / 13 Days',
//       destinations: 'Yamunotri • Gangotri • Kedarnath • Badrinath',
//       price: '₹32,999',
//       originalPrice: '₹36,999',
//       image: 'https://images.unsplash.com/photo-1585159812596-fac104f2f069?w=500&h=300&fit=crop',
//       rating: 4.7,
//       reviews: 134,
//       features: ['Tempo Traveller', 'Hotels', 'All Meals', 'Spiritual Guide'],
//       badge: 'Spiritual',
//       discount: '10% OFF'
//     },
//     {
//       id: 7,
//       title: 'Jim Corbett Wildlife',
//       category: ['adventure'],
//       duration: '3 Nights / 4 Days',
//       destinations: 'Jim Corbett National Park',
//       price: '₹9,999',
//       originalPrice: '₹11,499',
//       image: 'https://images.unsplash.com/photo-1549366021-9f761d450615?w=500&h=300&fit=crop',
//       rating: 4.6,
//       reviews: 98,
//       features: ['Safari Jeep', 'Forest Lodge', 'Jungle Safari', 'Bird Watching'],
//       badge: 'Wildlife',
//       discount: '10% OFF'
//     },
//     {
//       id: 8,
//       title: 'Goa Beach Holiday',
//       category: ['honeymoon', 'popular'],
//       duration: '5 Nights / 6 Days',
//       destinations: 'North Goa • South Goa',
//       price: '₹15,999',
//       originalPrice: '₹17,999',
//       image: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=500&h=300&fit=crop',
//       rating: 4.8,
//       reviews: 223,
//       features: ['Beach Resort', 'Water Sports', 'Sightseeing', 'Candlelight Dinner'],
//       badge: 'Relaxing',
//       discount: '10% OFF'
//     },
//     {
//       id: 9,
//       title: 'Kerala Backwaters',
//       category: ['honeymoon', 'popular'],
//       duration: '6 Nights / 7 Days',
//       destinations: 'Munnar • Thekkady • Alleppey • Cochin',
//       price: '₹19,999',
//       originalPrice: '₹22,999',
//       image: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=500&h=300&fit=crop',
//       rating: 4.9,
//       reviews: 187,
//       features: ['Houseboat', 'Hill Station Stay', 'Ayurvedic Spa', 'Tea Gardens'],
//       badge: 'Serene',
//       discount: '10% OFF'
//     }
//   ];

//   const filteredPackages = activeCategory === 'all' 
//     ? packages 
//     : packages.filter(pkg => pkg.category.includes(activeCategory));

//   return (
//     <section
//       id="packages"
//       className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900 relative overflow-hidden"
//     >
//       {/* Animated Background */}
//       <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
//       <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>

//       <div className="max-w-7xl mx-auto relative z-10">
//         {/* Section Header */}
//         <div className="text-center mb-12 sm:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-blue-300 to-orange-400 drop-shadow mb-4">
//             Explore Our Tour Packages
//           </h2>
//           <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-300">
//             Handpicked destinations and carefully crafted itineraries for your perfect vacation
//           </p>
//           <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-500 to-orange-500 mx-auto rounded-full mt-4"></div>
//         </div>

//         {/* Category Filters */}
//         <div className="flex flex-wrap justify-center gap-3 mb-12">
//           {categories.map((category) => (
//             <button
//               key={category.id}
//               onClick={() => setActiveCategory(category.id)}
//               className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 ${
//                 activeCategory === category.id
//                   ? 'bg-gradient-to-r from-blue-500 to-orange-500 text-white shadow-lg shadow-blue-500/50 scale-105'
//                   : 'bg-gray-800/50 backdrop-blur-sm text-gray-300 hover:bg-gray-700/50 border border-blue-500/20 shadow-md'
//               }`}
//             >
//               <span className="mr-2">{category.icon}</span>
//               {category.label}
//             </button>
//           ))}
//         </div>

//         {/* Packages Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
//           {filteredPackages.map((pkg, index) => (
//             <div
//               key={pkg.id}
//               className="bg-gray-800/50 backdrop-blur-sm rounded-2xl shadow-lg border border-blue-500/20 overflow-hidden hover:shadow-2xl hover:shadow-blue-500/20 hover:-translate-y-2 transition-all duration-300 group"
//               style={{ animationDelay: `${index * 0.1}s` }}
//             >
//               {/* Image */}
//               <div className="relative overflow-hidden h-48 sm:h-56">
//                 <img
//                   src={pkg.image}
//                   alt={pkg.title}
//                   className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                 />
//                 {/* Badge */}
//                 <div className="absolute top-3 left-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
//                   {pkg.badge}
//                 </div>
//                 {/* Discount */}
//                 <div className="absolute top-3 right-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
//                   {pkg.discount}
//                 </div>
//               </div>

//               {/* Content */}
//               <div className="p-5 sm:p-6">
//                 {/* Title & Rating */}
//                 <div className="flex items-start justify-between mb-3">
//                   <h3 className="text-xl font-bold text-white group-hover:text-blue-400 transition-colors">
//                     {pkg.title}
//                   </h3>
//                   <div className="flex items-center gap-1 bg-blue-500/20 px-2 py-1 rounded-lg border border-blue-400/30">
//                     <svg className="w-4 h-4 text-orange-400" fill="currentColor" viewBox="0 0 20 20">
//                       <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                     </svg>
//                     <span className="text-xs font-semibold text-gray-200">{pkg.rating}</span>
//                   </div>
//                 </div>

//                 {/* Duration & Destinations */}
//                 <div className="space-y-2 mb-4">
//                   <div className="flex items-center gap-2 text-sm text-gray-300">
//                     <svg className="w-4 h-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                     </svg>
//                     <span className="font-medium">{pkg.duration}</span>
//                   </div>
//                   <div className="flex items-center gap-2 text-sm text-gray-300">
//                     <svg className="w-4 h-4 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//                     </svg>
//                     <span className="font-medium">{pkg.destinations}</span>
//                   </div>
//                 </div>

//                 {/* Features */}
//                 <div className="flex flex-wrap gap-2 mb-4">
//                   {pkg.features.map((feature, i) => (
//                     <span
//                       key={i}
//                       className="px-3 py-1 bg-blue-500/20 text-blue-300 rounded-full text-xs font-medium border border-blue-400/30"
//                     >
//                       {feature}
//                     </span>
//                   ))}
//                 </div>

//                 {/* Price & CTA */}
//                 <div className="flex items-center justify-between pt-4 border-t border-gray-700">
//                   <div>
//                     <div className="flex items-baseline gap-2">
//                       <span className="text-2xl font-bold text-blue-400">{pkg.price}</span>
//                       <span className="text-sm text-gray-500 line-through">{pkg.originalPrice}</span>
//                     </div>
//                     <p className="text-xs text-gray-400">Per Person</p>
//                   </div>
//                   <a
//                     href={`https://wa.me/918929550611?text=Hi! I'm interested in ${pkg.title}`}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="px-5 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-full shadow-md hover:shadow-lg hover:shadow-orange-500/50 hover:scale-105 transition-all duration-300 text-sm"
//                   >
//                     Book Now
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Bottom CTA */}
//         <div className="mt-12 sm:mt-16 text-center">
//           <div className="inline-block bg-gradient-to-r from-blue-500 via-blue-400 to-orange-500 p-1 rounded-2xl shadow-2xl shadow-blue-500/30">
//             <div className="bg-gray-900 px-8 py-6 rounded-2xl">
//               <h3 className="text-2xl font-bold text-white mb-2">
//                 Can't find what you're looking for?
//               </h3>
//               <p className="text-gray-300 mb-4">
//                 We create customized tour packages tailored to your preferences!
//               </p>
//               <div className="flex flex-col sm:flex-row gap-3 justify-center">
//                 <a
//                   href="https://wa.me/918929550611"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold rounded-full shadow-lg hover:shadow-orange-500/50 hover:scale-105 transition-all duration-200"
//                 >
//                   📱 WhatsApp Us
//                 </a>
//                 <a
//                   href="tel:+918929550611"
//                   className="px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold rounded-full shadow-lg hover:shadow-blue-500/50 hover:scale-105 transition-all duration-200"
//                 >
//                   📞 Call Now
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// import React, { useState } from 'react';

// export default function Packages() {
//   const [activeCategory, setActiveCategory] = useState('all');

//   const categories = [
//     { id: 'all', label: 'All Packages', icon: '🗺️' },
//     { id: 'popular', label: 'Popular', icon: '⭐' },
//     { id: 'adventure', label: 'Adventure', icon: '🏔️' },
//     { id: 'heritage', label: 'Heritage', icon: '🏛️' },
//     { id: 'honeymoon', label: 'Honeymoon', icon: '💑' }
//   ];

//   const packages = [
//     {
//       id: 1,
//       title: 'Golden Triangle Tour',
//       category: ['popular', 'heritage'],
//       duration: '6 Nights / 7 Days',
//       destinations: 'Delhi • Agra • Jaipur',
//       price: '₹12,999',
//       originalPrice: '₹15,999',
//       image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=500&h=300&fit=crop',
//       rating: 4.8,
//       reviews: 245,
//       features: ['Tempo Traveller', 'Hotel Stay', 'Meals', 'Guide'],
//       badge: 'Best Seller',
//       discount: '20% OFF'
//     },
//     {
//       id: 2,
//       title: 'Shimla Manali Tour',
//       category: ['popular', 'adventure', 'honeymoon'],
//       duration: '8 Nights / 7 Days',
//       destinations: 'Shimla • Manali • Kullu',
//       price: '₹18,499',
//       originalPrice: '₹22,999',
//       image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=500&h=300&fit=crop',
//       rating: 4.9,
//       reviews: 189,
//       features: ['Luxury Car', 'Mountain Resorts', 'All Meals', 'Activities'],
//       badge: 'Top Rated',
//       discount: '15% OFF'
//     },
//     {
//       id: 3,
//       title: 'Rajasthan Heritage Tour',
//       category: ['heritage', 'popular'],
//       duration: '10 Nights / 11 Days',
//       destinations: 'Jaipur • Udaipur • Jodhpur • Jaisalmer',
//       price: '₹24,999',
//       originalPrice: '₹29,999',
//       image: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?w=500&h=300&fit=crop',
//       rating: 4.7,
//       reviews: 156,
//       features: ['Tempo Traveller', 'Heritage Hotels', 'Cultural Tours', 'Camel Safari'],
//       badge: 'Premium',
//       discount: '15% OFF'
//     },
//     {
//       id: 4,
//       title: 'Kashmir Paradise Tour',
//       category: ['honeymoon', 'adventure'],
//       duration: '6 Nights / 7 Days',
//       destinations: 'Srinagar • Gulmarg • Pahalgam • Sonmarg',
//       price: '₹21,999',
//       originalPrice: '₹26,999',
//       image: 'https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=500&h=300&fit=crop',
//       rating: 4.9,
//       reviews: 201,
//       features: ['Houseboat Stay', 'Shikara Ride', 'All Transfers', 'Romantic Setup'],
//       badge: 'Romantic',
//       discount: '20% OFF'
//     },
//     {
//       id: 5,
//       title: 'Leh Ladakh Adventure',
//       category: ['adventure'],
//       duration: '8 Nights / 9 Days',
//       destinations: 'Leh • Nubra • Pangong • Khardung La',
//       price: '₹28,999',
//       originalPrice: '₹34,999',
//       image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
//       rating: 4.8,
//       reviews: 178,
//       features: ['SUV/Tempo', 'Camping', 'Oxygen Support', 'Adventure Activities'],
//       badge: 'Thrilling',
//       discount: '15% OFF'
//     },
//     {
//       id: 6,
//       title: 'Char Dham Yatra',
//       category: ['heritage'],
//       duration: '12 Nights / 13 Days',
//       destinations: 'Yamunotri • Gangotri • Kedarnath • Badrinath',
//       price: '₹32,999',
//       originalPrice: '₹38,999',
//       image: 'https://images.unsplash.com/photo-1585159812596-fac104f2f069?w=500&h=300&fit=crop',
//       rating: 4.7,
//       reviews: 134,
//       features: ['Tempo Traveller', 'Hotels', 'All Meals', 'Spiritual Guide'],
//       badge: 'Spiritual',
//       discount: '15% OFF'
//     },
//     {
//       id: 7,
//       title: 'Jim Corbett Wildlife',
//       category: ['adventure'],
//       duration: '3 Nights / 4 Days',
//       destinations: 'Jim Corbett National Park',
//       price: '₹9,999',
//       originalPrice: '₹12,999',
//       image: 'https://images.unsplash.com/photo-1549366021-9f761d450615?w=500&h=300&fit=crop',
//       rating: 4.6,
//       reviews: 98,
//       features: ['Safari Jeep', 'Forest Lodge', 'Jungle Safari', 'Bird Watching'],
//       badge: 'Wildlife',
//       discount: '20% OFF'
//     },
//     {
//       id: 8,
//       title: 'Goa Beach Holiday',
//       category: ['honeymoon', 'popular'],
//       duration: '5 Nights / 6 Days',
//       destinations: 'North Goa • South Goa',
//       price: '₹15,999',
//       originalPrice: '₹19,999',
//       image: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=500&h=300&fit=crop',
//       rating: 4.8,
//       reviews: 223,
//       features: ['Beach Resort', 'Water Sports', 'Sightseeing', 'Candlelight Dinner'],
//       badge: 'Relaxing',
//       discount: '20% OFF'
//     },
//     {
//       id: 9,
//       title: 'Kerala Backwaters',
//       category: ['honeymoon', 'popular'],
//       duration: '6 Nights / 7 Days',
//       destinations: 'Munnar • Thekkady • Alleppey • Cochin',
//       price: '₹19,999',
//       originalPrice: '₹24,999',
//       image: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=500&h=300&fit=crop',
//       rating: 4.9,
//       reviews: 187,
//       features: ['Houseboat', 'Hill Station Stay', 'Ayurvedic Spa', 'Tea Gardens'],
//       badge: 'Serene',
//       discount: '20% OFF'
//     }
//   ];

//   const filteredPackages = activeCategory === 'all' 
//     ? packages 
//     : packages.filter(pkg => pkg.category.includes(activeCategory));

//   return (
//     <section
//       id="packages"
//       className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-white via-purple-50 to-blue-50"
//     >
//       <div className="max-w-7xl mx-auto">
//         {/* Section Header */}
//         <div className="text-center mb-12 sm:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-600 to-pink-500 drop-shadow mb-4">
//             Explore Our Tour Packages
//           </h2>
//           <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-700">
//             Handpicked destinations and carefully crafted itineraries for your perfect vacation
//           </p>
//           <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full mt-4"></div>
//         </div>

//         {/* Category Filters */}
//         <div className="flex flex-wrap justify-center gap-3 mb-12">
//           {categories.map((category) => (
//             <button
//               key={category.id}
//               onClick={() => setActiveCategory(category.id)}
//               className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 ${
//                 activeCategory === category.id
//                   ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg scale-105'
//                   : 'bg-white text-gray-700 hover:bg-gray-100 shadow-md'
//               }`}
//             >
//               <span className="mr-2">{category.icon}</span>
//               {category.label}
//             </button>
//           ))}
//         </div>

//         {/* Packages Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
//           {filteredPackages.map((pkg, index) => (
//             <div
//               key={pkg.id}
//               className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 group"
//               style={{ animationDelay: `${index * 0.1}s` }}
//             >
//               {/* Image */}
//               <div className="relative overflow-hidden h-48 sm:h-56">
//                 <img
//                   src={pkg.image}
//                   alt={pkg.title}
//                   className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                 />
//                 {/* Badge */}
//                 <div className="absolute top-3 left-3 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
//                   {pkg.badge}
//                 </div>
//                 {/* Discount */}
//                 <div className="absolute top-3 right-3 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
//                   {pkg.discount}
//                 </div>
//               </div>

//               {/* Content */}
//               <div className="p-5 sm:p-6">
//                 {/* Title & Rating */}
//                 <div className="flex items-start justify-between mb-3">
//                   <h3 className="text-xl font-bold text-gray-800 group-hover:text-purple-600 transition-colors">
//                     {pkg.title}
//                   </h3>
//                   <div className="flex items-center gap-1 bg-green-50 px-2 py-1 rounded-lg">
//                     <svg className="w-4 h-4 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
//                       <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                     </svg>
//                     <span className="text-xs font-semibold text-gray-700">{pkg.rating}</span>
//                   </div>
//                 </div>

//                 {/* Duration & Destinations */}
//                 <div className="space-y-2 mb-4">
//                   <div className="flex items-center gap-2 text-sm text-gray-600">
//                     <svg className="w-4 h-4 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                     </svg>
//                     <span className="font-medium">{pkg.duration}</span>
//                   </div>
//                   <div className="flex items-center gap-2 text-sm text-gray-600">
//                     <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//                     </svg>
//                     <span className="font-medium">{pkg.destinations}</span>
//                   </div>
//                 </div>

//                 {/* Features */}
//                 <div className="flex flex-wrap gap-2 mb-4">
//                   {pkg.features.map((feature, i) => (
//                     <span
//                       key={i}
//                       className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-xs font-medium"
//                     >
//                       {feature}
//                     </span>
//                   ))}
//                 </div>

//                 {/* Price & CTA */}
//                 <div className="flex items-center justify-between pt-4 border-t border-gray-100">
//                   <div>
//                     <div className="flex items-baseline gap-2">
//                       <span className="text-2xl font-bold text-purple-600">{pkg.price}</span>
//                       <span className="text-sm text-gray-400 line-through">{pkg.originalPrice}</span>
//                     </div>
//                     <p className="text-xs text-gray-500">Per Person</p>
//                   </div>
//                   <a
//                     href={`https://wa.me/917027005176?text=Hi! I'm interested in ${pkg.title}`}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="px-5 py-2.5 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-full shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 text-sm"
//                   >
//                     Book Now
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Bottom CTA */}
//         <div className="mt-12 sm:mt-16 text-center">
//           <div className="inline-block bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 p-1 rounded-2xl shadow-xl">
//             <div className="bg-white px-8 py-6 rounded-2xl">
//               <h3 className="text-2xl font-bold text-gray-800 mb-2">
//                 Can't find what you're looking for?
//               </h3>
//               <p className="text-gray-600 mb-4">
//                 We create customized tour packages tailored to your preferences!
//               </p>
//               <div className="flex flex-col sm:flex-row gap-3 justify-center">
//                 <a
//                   href="https://wa.me/917027005176"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white font-bold rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
//                 >
//                   📱 WhatsApp Us
//                 </a>
//                 <a
//                   href="tel:+917027005176"
//                   className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-bold rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
//                 >
//                   📞 Call Now
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }